import React, { useState } from 'react';
import Filter from '../../components/Filter/Filter';
import DataMap from '../../components/DataMap/DataMap';
import { Icon } from 'leaflet';
import ActionGrid from '../../components/ActionGrid/ActionGrid';
import dayjs from 'dayjs';
import {useDeviceFilter} from '../../hooks/useFilter';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import SendLightCommand from '../../components/SendLightCommand/SendLightCommand';
import { fetchDevices, getModalData } from '../../Helpers/fetchDevices';
import { exportAutonomusDevices } from '../../Helpers/exportFunctions';
const customIcon = new Icon({
    iconUrl : require('../../components/DataMap/assets/marker.png'),
    iconSize: [38,38]
})


const actions = [
    'active',
    'dim',
    'error',
    'off',
    'selected',
    'deverror',
];

const StreetLightControl = () => {
    const [selectedDevices, setSelectedDevices] = useState([]);
    const [filters, setFilters] = useState({
        fromDate: dayjs().add(-1, "day"),
        toDate: dayjs().add(1, "day"),
        fromTime: dayjs().hour(12).minute(0),
        toTime: dayjs().hour(12).minute(0),
        deviceStates: {
          active: true,
          dim: true,
          error: true,
          off: true,
          selected: true,
          deverror: true,
        },
    });


    const { devices, statusCounts, handleSearchClick, exportDevices} = useDeviceFilter(filters, fetchDevices, "autonomus", exportAutonomusDevices);
    
    const handleMarkersSelected = (results) => {
      if (results) {
        setSelectedDevices(results);
      }
    };

    return (
        <>  
        <div className="mb-4">
            <ActionGrid actions = {actions} statusCounts = {statusCounts}/>
            <Button
                variant="contained"
                sx={{ mt: 2, alignSelf: 'flex-start' }}
                onClick={exportDevices}
              >
                Εξαγωγή
            </Button>
        </div>
        
        <div className="mb-4">
        <Filter filters={filters} setFilters={setFilters} onSearch={handleSearchClick} />
        </div>
        
        <div className="mb-4">
          <DataMap markers ={devices} customIcon = {customIcon} deviceType ={"autonomus"} onMarkersSelected={handleMarkersSelected} modalFetcher={getModalData}/>
          </div>

          <div className="mb-4">
    <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} sm={6} md={5}>
            <SendLightCommand actionImage={"fa fa-map-pin text-info"} deviceChoice={"επιλεγμένες συσκευές"} devices={selectedDevices} deviceType={"autonomus"}/>
        </Grid>
        <Grid item xs={12} sm={6} md={5}>
            <SendLightCommand actionImage={"fa fa-lightbulb text-info"} deviceChoice={"ολες τις Συσκευές"} devices={devices} deviceType={"autonomus"}/>
        </Grid>
    </Grid>
</div>
        </>

    );
};

export default StreetLightControl;

